import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { httpinstance,httpinstancefile } from "../../../axios/api"

// Async thunk for fetching airline products
export const getAirlineProduct = createAsyncThunk('airlineProduct/getAirlineProduct', async () => {
  try {
    const url = `airline-product/product-details`;
    const response = await httpinstance.get(url);
    return response.data;
  } catch (err) {
    console.log("error",err)  
    return err
    // throw new Error(err|| 'Failed to fetch airline products');
  }
});
export const getAirlineProductbyId = createAsyncThunk('airlineProduct/getAirlineProductbyId', async (id) => {
    try {
      const url = `airline-product/product-details/${id}`;
      const response = await httpinstance.get(url);
      return response.data;
    } catch (err) {
      throw new Error(err.response?.data || 'Failed to fetch airline products');
    }
  });
  export const newairlineproduct = createAsyncThunk('airlineProduct/newairlineproduct', async (value) => {
    try {
      const url = `airline-product/product-details`;
      const response = await httpinstance.post(url,value);
      return response.data;
    } catch (err) {
      // newairlineproducterror=err
      console.log("erroradd",err)
      return err.response
      // throw new Error(err.response?.data || 'Failed to fetch airline products');
    }
  });
///airline-product/product-details
export const updateairlineproduct = createAsyncThunk('airlineProduct/updateairlineproduct', async (value) => {
  try {
    const url = `airline-product/product-details`;
    const response = await httpinstance.put(url,value);
    return response.data;
  } catch (err) {
    // throw new Error(err.response?.data || 'Failed to fetch airline products');
    return err.response
  }
});
export const getairlineproduct = createAsyncThunk('airlineProduct/getairlineproduct', async (value) => {
  try {
    const url = `/airline-product/product-type?carr_code=${value}`;
    const response = await httpinstance.get(url,value);
    return response.data;
  } catch (err) {
    throw new Error(err.response?.data || 'Failed to fetch airline products');
  }
});
// Initial state
const initialState = {
  airlineProducts: [],
  error: null,
  loading: false,
  airlineproductbyid:[],
  errorbyid:null,
  loadingbyid:false,
  newairlineproduct:[],
  newairlineproducterror:null,
  updateairlineproduct:[],
  updateairlineproducterror:null,
  getairlineproduct:[],
  getairlineproducterror:null
};

// Airline product slice
const airlineProductSlice = createSlice({
  name: 'airlineProduct',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAirlineProduct.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAirlineProduct.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.airlineProducts = payload;
      })
      .addCase(getAirlineProduct.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        console.error('Error fetching airline products:', action.error.message);
      })
      .addCase(getAirlineProductbyId.pending, (state) => {
        state.loadingbyid = true;
        state.errorbyid = null;
      })
      .addCase(getAirlineProductbyId.fulfilled, (state, { payload }) => {
        state.loadingbyid = false;
        state.airlineproductbyid = payload; 
      }).addCase(getAirlineProductbyId.rejected, (state, action) => {
        state.loadingbyid = false;
        state.errorbyid = action.error.message;
        console.error('Error fetching airline products:', action.error.message);
      }).addCase(newairlineproduct.fulfilled, (state, { payload }) => {
        state.newairlineproduct=payload;
      }).addCase(newairlineproduct.rejected, (state, action) => {
        state.newairlineproducterror=action.error.message;
        console.error('Error fetching airline products:', action.error.message);
      }).addCase(updateairlineproduct.fulfilled,(state,{payload})=>{
        state.updateairlineproduct=payload
      }).addCase(updateairlineproduct.rejected,(state,action)=>{
       state.updateairlineproduct=action.error.message;
       console.error('Error fetching airline products:', action.error.message);
      }).addCase(getairlineproduct.fulfilled,(state,{payload})=>{
        state.getairlineproduct=payload
      }).addCase(getairlineproduct.rejected,(state,action)=>{
        state.getairlineproduct=action.error.message;
        console.error('Error fetching airline products:', action.error.message);
      })
   
  },
});

// Export reducer
export default airlineProductSlice.reducer;
